"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLSnappableCollectionContext = exports.OLSnapProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Collection_1 = __importDefault(require("ol/Collection"));
const Snap_1 = __importDefault(require("ol/interaction/Snap"));
const react_1 = require("react");
const useOLMap_1 = require("../openlayers/useOLMap");
function OLSnapProvider({ children }) {
    const map = useOLMap_1.useOLMap();
    const [snappableOLFeatures] = react_1.useState(() => new Collection_1.default([]));
    const snapInteraction = react_1.useMemo(() => {
        const interaction = new Snap_1.default({
            features: snappableOLFeatures,
        });
        interaction.set('caresAboutOrder', true);
        interaction.set('isSnapInteraction', true);
        return interaction;
    }, [snappableOLFeatures]);
    react_1.useEffect(() => {
        map.addInteraction(snapInteraction);
        return () => {
            map.removeInteraction(snapInteraction);
        };
    }, [map, snapInteraction]);
    const mapInteractions = map.getInteractions();
    react_1.useEffect(() => {
        const onAdd = (e) => {
            if (!e.element.get('caresAboutOrder')) {
                map.removeInteraction(snapInteraction);
                map.addInteraction(snapInteraction);
            }
        };
        mapInteractions.on('add', onAdd);
        return () => {
            mapInteractions.un('add', onAdd);
        };
    }, [map, mapInteractions, snapInteraction]);
    return (jsx_runtime_1.jsx(exports.OLSnappableCollectionContext.Provider, Object.assign({ value: snappableOLFeatures }, { children: children }), void 0));
}
exports.OLSnapProvider = OLSnapProvider;
exports.OLSnappableCollectionContext = react_1.createContext(new Collection_1.default());
//# sourceMappingURL=OLSnapProvider.js.map